import { useMemo, useState } from 'react'
import { getDayJsDateFromMilliseconds } from 'src/business/helpers/helperFunctions'
import { MuiAddPracticeTimerTimeClockInput } from '../styledComponents'
import { AddIntervalButton, AddIntervalPopoverContainer } from './styledComponents'

export default function AddInterval({
  handleAddInterval,
  durationToToNotExceed = 100000,
  allIntervals,
}) {
  const [duration, setDuration] = useState(10000)

  const validationMessage = useMemo(() => {
    if (isNaN(duration) || duration <= 0) {
      return 'Please enter a valid timer duration'
    }
    if (duration >= durationToToNotExceed) {
      return `Timer Duration must be less than ${getDayJsDateFromMilliseconds(
        durationToToNotExceed,
      ).format('mm:ss')}`
    }

    if (allIntervals?.find((interval) => interval === duration)) {
      return 'This interval already exists'
    }

    return ''
  }, [duration, durationToToNotExceed, allIntervals])

  function convertMomentDateIntoMilliSeconds(originalMilliseconds, dayJsDate) {
    if (!dayJsDate?.isValid()) {
      return NaN
    }

    return dayJsDate.minute() * 60 * 1000 + dayJsDate.second() * 1000
  }
  return (
    <AddIntervalPopoverContainer>
      <MuiAddPracticeTimerTimeClockInput
        value={getDayJsDateFromMilliseconds(duration)}
        format="mm:ss"
        onChange={(val) => setDuration((prev) => convertMomentDateIntoMilliSeconds(prev, val))}
      />
      <div style={{ color: '#d84444', width: '100%', textAlign: 'center' }}>
        {validationMessage}
      </div>
      <AddIntervalButton
        disabled={
          isNaN(duration) ||
          duration <= 0 ||
          duration >= durationToToNotExceed ||
          allIntervals?.some((interval) => interval === duration)
        }
        onClick={() => handleAddInterval(duration)}
      >
        Add Interval
      </AddIntervalButton>
    </AddIntervalPopoverContainer>
  )
}
